import React, { useEffect } from 'react'
import FormInput from './form-input/FormInput'
import { FieldValues, Path, PathValue, useWatch } from 'react-hook-form'
import { CurrencyPropTypes, formatCurrency, softFormatCurrency } from '../utils'

const CurrencyInput = <T extends FieldValues>({
  name,
  setValue,
  control,
  ...rest
}: CurrencyPropTypes<T>) => {
  const fieldValue = useWatch({
    control,
    name: name as Path<T>,
  })

  const onBlur = (val: string) => {
    if (val === '') return

    setValue?.(name, formatCurrency(val) as PathValue<T, Path<T>>)
  }

  useEffect(() => {
    const formattedValue = (
      typeof fieldValue === 'number' ? formatCurrency : softFormatCurrency
    )(fieldValue?.toString())
    if (fieldValue !== formattedValue) {
      setValue?.(name, formattedValue as PathValue<T, Path<T>>)
    }
  }, [fieldValue])

  return (
    <FormInput
      {...rest}
      name={name}
      onBlur={(e) => onBlur(e?.target?.value ?? '')}
      defaultValue={formatCurrency(rest.defaultValue as string)}
    />
  )
}

export default CurrencyInput
